module.exports = __webpack_public_path__ + "/login_ui/img/ml-4a96b7088e90703e38c820ba4248362d.svg";